<template>
  <div class="PageHead-container">
    <div v-if="HeadType === ''" class="header slider-bg-image" :style="{ 'background-image': `url(${pageHeadData.image})` }">
      <div class="eng_title">{{ pageHeadData.engTitle }}</div>
      <div class="line">────</div>
      <div class="text">{{ pageHeadData.text }}</div>
      <div class="subtitle">{{ pageHeadData.subtitle }}</div>
    </div>

    <div v-if="HeadType === 'FCST'" class="FCST_header slider-bg-image" :style="{ 'background-image': `url(${pageHeadData.image})` }">
        <div class="eng_title">{{ pageHeadData.engTitle }}</div>
        <div class="title_first">{{ pageHeadData.text01 }}</div>
        <div class="title_second">{{ pageHeadData.text02 }}</div>
        <div class="line">────</div>
        <div class="subtitle">{{ pageHeadData.subtitle }}</div>
    </div>

    <div v-if="HeadType === 'LTC'">
      <div class="LTC_header slider-bg-image" :style="{ 'background-image': `url(${pageHeadData.image})` }">
        <div class="eng_title">{{ pageHeadData.engTitle }}</div>
        <div class="text">{{ pageHeadData.text }}</div>
        <div class="subtitle">{{ pageHeadData.subtitle }}</div>
      </div>
    </div>

    <div v-if="HeadType === 'Service'">
      <div class="service_text slider-bg-image" 
        :style="{ 'background-image': `url(${require('@/assets/images/ProductService/VyungService/Service-Image.png')})` }">
        <div class="title_first">
          {{ this.$t('product.VyungService.head.text01') }}
          <span class="highlight">{{ this.$t('product.VyungService.head.text02') }}</span>
          {{ this.$t('product.VyungService.head.text03') }}
        </div>
        <div class="title_second">
          <span class="highlight">{{ this.$t('product.VyungService.head.text04') }}</span>
          {{ this.$t('product.VyungService.head.text05') }}
        </div>
        <div class="text_content">
          <div class="text">
            <div>{{ this.$t('product.VyungService.head.subtitle01') }}</div>
            {{ this.$t('product.VyungService.head.subtext01') }}
          </div>
          <div class="text">
            <div>{{ this.$t('product.VyungService.head.subtitle02') }}</div>
            {{ this.$t('product.VyungService.head.subtext02') }}
          </div>
          <div class="text">
            <div>{{ this.$t('product.VyungService.head.subtitle03') }}</div>
            {{ this.$t('product.VyungService.head.subtext03') }}
          </div>
        </div>
      </div>
    </div>

    <div v-if="HeadType === 'Workflow'" class="Workflow_header slider-bg-image" :style="{ 'background-image': `url(${require('@/assets/images/ProductService/VyungWorkflow/Workflow_Image.png')})` }">
        <div class="text01">{{ this.$t('product.VyungWorkflow.head.text01') }}</div>
        <div class="text02">{{ this.$t('product.VyungWorkflow.head.text02') }}</div>
        <div class="line">────</div>
        <div class="subtitle">{{ this.$t('product.VyungWorkflow.head.subtitle') }}</div>
    </div>
  </div>
</template>

<script>
    import VyungWorkflow from '../VyungWorkflow'
export default {
        name: 'PageHead',
        components: {
    VyungWorkflow,},
        props:{
          'pageHeadData': {
            type: Object,
            default:()=>{ return {} },
          },
          'HeadType':{
            type:String,
            default:'',
          },
        },
        data() {
            return {
                // CPQImage: require('@/assets/images/ProductService/VyungCPQ/CPQ-Image.png'), 
            }
        },
        methods:{

        }
    }
</script>